import { render, staticRenderFns } from "./financial.vue?vue&type=template&id=18638ffa&scoped=true&"
import script from "./financial.vue?vue&type=script&lang=js&"
export * from "./financial.vue?vue&type=script&lang=js&"
import style0 from "./financial.vue?vue&type=style&index=0&id=18638ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18638ffa",
  null
  
)

export default component.exports